/**
 * Created by yoavp on 8/25/2015.
 */
define(function (require) {
    "use strict";

    var BaseModel = require("models/BaseModel");
    var LE = require("app");

    var AgentGroupsMembersGridModel = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        AgentGroupsMembersGridModel = BaseModel.extend({
            defaults: {
                comparators:{
                    "name":"fullName",
                    "maxChats":"maxChats",
                    "maxConversations":"maxConversations",
                    "assignmentDate":"memberOf.assignmentDate"
                }
            },
            name: "AgentGroupsMembersGridModel"
        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    return AgentGroupsMembersGridModel;
});


